import { render, staticRenderFns } from "./CardComentariosTitulo.vue?vue&type=template&id=365f87ad&scoped=true"
import script from "./CardComentariosTitulo.vue?vue&type=script&lang=js"
export * from "./CardComentariosTitulo.vue?vue&type=script&lang=js"
import style0 from "./CardComentariosTitulo.vue?vue&type=style&index=0&id=365f87ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f87ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365f87ad')) {
      api.createRecord('365f87ad', component.options)
    } else {
      api.reload('365f87ad', component.options)
    }
    module.hot.accept("./CardComentariosTitulo.vue?vue&type=template&id=365f87ad&scoped=true", function () {
      api.rerender('365f87ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardComentariosTitulo.vue"
export default component.exports